// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gAp6","left":"styles_left___TWci"};